/* eslint-disable no-debugger */
import React from 'react'
import {Tooltip} from '../core/shared/Tooltip'
import {Elements} from '@recurly/react-recurly'
import {
  Button,
  Icon,
  ParagraphText,
  Checkbox,
  Select,
} from '@thryvlabs/maverick'
// import rawCountryStates from 'iso3166-2-db/i18n/en'
import {TaxesPromptContainer} from '../ui-view/payment-information'
import {AutopayTerms} from './autopay-terms'
import {usePaymentAddress} from './keap-partner/payment-information-components/contexts/payment-address-context'
import {usePaymentCheckboxes} from './keap-partner/payment-information-components/contexts/payment-checkboxes-context'
import {COUNTRIES} from './keap-partner/payment-information-components/constants'
// import {usePaymentOrder} from './keap-partner/payment-information-components/hooks/use-payment-order'
import {useDispatch, useSelector} from 'react-redux'
import {nextPaymentStep, setPaymentStep} from '../redux/paymentScreenViewSlice'
import {usePaymentBankAccount} from './keap-partner/payment-information-components/contexts/payment-bank-account-context'
import {useRecurly} from '@recurly/react-recurly'
import {setRecurlyTokenData} from '../redux/recurlySlice'
import {toast} from 'react-toastify'
import {fetchSelectedCountryRegionList} from '../utils/address-validation'
const ACCOUNT_TYPE_OPTIONS = [
  {label: 'Checking', value: 'checking'},
  {label: 'Savings', value: 'savings'},
]

const ADDRESS_FORM_FIELDS = new Set([
  'firstName',
  'lastName',
  'company',
  'phone',
  'address',
  'city',
  'state',
  'postalCode',
])

const BANK_ACCOUNT_FORM_FIELDS = new Set([
  'accountName',
  'routingNumber',
  'accountNumber',
  'accountNumberConfirmation',
])

const AchRecurlyPaymentForm = ({
  showFirstSection,
  showSecondSection,
  nextStep,
  businessAddress,
  country,
  setIsAddressUpdated,
  bizphone,
  isAddressUpdated,
  disclaimerText,
  allowCountryChange = false,
  skipOldMobile = false,
}) => {
  const [selectedCountry, setSelectedCountry] = React.useState(
    COUNTRIES.find(({value}) => value === country),
  )

  const {
    addressInformation,
    isValidAddress,
    updateAddressField,
    updateFullAddress,
    setFromBusinessAddress,
  } = usePaymentAddress()
  const {checkBoxesValues, setCheckBoxesValues} = usePaymentCheckboxes()
  const {is5Order} = true //usePaymentOrder()
  const {bankAccountInformation, updateBankAccountField, isValidBankAccount} =
    usePaymentBankAccount()
  const [listOfStates, setListOfStates] = React.useState([])
  const formRef = React.useRef()
  const {useBusinessAddressInfo} = checkBoxesValues
  const previousUseBusinessAddressInfoRef = React.useRef(useBusinessAddressInfo)
  // const {frontendUpdatedTerms} = useFlags()
  const frontendUpdatedTerms = true

  const isAusNZ = ['AU', 'NZ'].includes(country)
  const dispatch = useDispatch()
  const {isMobileViewEnable} = useSelector(state => state.screenView)
  const handleOnchange = ({target: {value, name}}) => {
    console.log('handle on change', name, value)
    updateAddressField(name, value)
  }
  const handleBankAccountChange = ({target: {value, name}}) => {
    console.log({name, value})
    updateBankAccountField(name, value)
  }

  const handleNativeFormChange = React.useCallback(
    event => {
      const {name, value} = event.target
      if (!name) return

      if (ADDRESS_FORM_FIELDS.has(name)) {
        updateAddressField(name, value)
      }

      if (BANK_ACCOUNT_FORM_FIELDS.has(name)) {
        updateBankAccountField(name, value)
      }
    },
    [updateAddressField, updateBankAccountField],
  )

  const syncDomValuesToState = React.useCallback(() => {
    if (!formRef.current) return

    for (const element of formRef.current.elements) {
      const {name, value} = element
      if (!name || value === undefined || value === null || value === '') {
        continue
      }

      if (ADDRESS_FORM_FIELDS.has(name)) {
        updateAddressField(name, value)
      }

      if (BANK_ACCOUNT_FORM_FIELDS.has(name)) {
        updateBankAccountField(name, value)
      }
    }
  }, [updateAddressField, updateBankAccountField])

  React.useEffect(() => {
    const getStates = () => {
      let stateLabel = ''
      if (['US', 'AU', 'NZ'].includes(selectedCountry.value)) {
        stateLabel = 'State'
      } else if (selectedCountry.value === 'KY') {
        stateLabel = 'City'
      } else if (selectedCountry.value === 'CA') {
        stateLabel = 'Province'
      } else if (selectedCountry.value === 'BB') {
        stateLabel = 'Parish'
      } else {
        stateLabel = 'State'
      }
      let blankOption = [{name: 'Select ' + stateLabel, value: ''}]
      // const states = rawCountryStates[selectedCountry.value].regions
      //   .map(({iso, name}) => ({
      //     name,
      //     value: iso,
      //   }))
      //   .sort((a, b) => (a.name > b.name ? 1 : -1))
      // setListOfStates([...blankOption, ...states])
      const data = fetchSelectedCountryRegionList(selectedCountry.value)
      setListOfStates([...blankOption, ...data])
    }
    if (selectedCountry.value) {
      getStates(selectedCountry.value)

      updateBankAccountField('country', selectedCountry.value)
    }
  }, [selectedCountry, updateBankAccountField])

  React.useEffect(() => {
    const wasUsingBusinessAddress = previousUseBusinessAddressInfoRef.current
    previousUseBusinessAddressInfoRef.current = useBusinessAddressInfo

    if (useBusinessAddressInfo) {
      if (checkBoxesValues.updateBillingAddress) {
        setCheckBoxesValues(prevState => ({
          ...prevState,
          updateBillingAddress: false,
        }))
      }
      // Pull any browser-autofilled DOM values into state first so they aren't
      // lost when businessAddress lacks a field (e.g., partner has no street).
      syncDomValuesToState()
      console.log({businessAddress})
      setFromBusinessAddress(businessAddress)
      updateBankAccountField(
        'accountName',
        businessAddress?.firstName && businessAddress?.lastName
          ? `${businessAddress.firstName} ${businessAddress.lastName}`
          : businessAddress?.accountName || '',
      )
    } else if (wasUsingBusinessAddress) {
      updateFullAddress({
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        state: '',
        postalCode: isMobileViewEnable ? addressInformation.postalCode : '',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [useBusinessAddressInfo, businessAddress, isMobileViewEnable])
  const {recurlyTokenDetail} = useSelector(state => state.recurlyTokenData)
  const recurly = useRecurly()

  const fetchBankAccountToken = React.useCallback(
    data => {
      recurly.bankAccount.token(data, (err, token) => {
        if (err) {
          dispatch(setPaymentStep(2))
          setCheckBoxesValues(prevState => ({
            ...prevState,
            agreedTerms: false,
          }))
          console.error(err)
          toast.error(err.message)
          return null
        }
        dispatch(setRecurlyTokenData(token))
      })
    },
    [dispatch, recurly.bankAccount, setCheckBoxesValues],
  )

  React.useEffect(() => {
    if (!checkBoxesValues.agreedTerms) return undefined
    if (recurlyTokenDetail) return undefined

    const bankAccountData = {
      name_on_account: bankAccountInformation.accountName,
      routing_number: bankAccountInformation.routingNumber,
      account_number: bankAccountInformation.accountNumber,
      account_number_confirmation:
        bankAccountInformation.accountNumberConfirmation,
      account_type: bankAccountInformation.accountType,
      postal_code: addressInformation.postalCode,
      country: bankAccountInformation.country,
      phone: addressInformation.phone,
      address1: addressInformation.address,
      city: addressInformation.city,
      state: addressInformation.state,
      business_name: addressInformation.company,
      business_phone: addressInformation.phone,
    }

    if (isValidBankAccount && isValidAddress) {
      fetchBankAccountToken(bankAccountData)
    }
  }, [
    addressInformation.address,
    addressInformation.city,
    addressInformation.company,
    addressInformation.phone,
    addressInformation.postalCode,
    addressInformation.state,
    bankAccountInformation.accountName,
    bankAccountInformation.accountNumber,
    bankAccountInformation.accountNumberConfirmation,
    bankAccountInformation.accountType,
    bankAccountInformation.country,
    bankAccountInformation.routingNumber,
    checkBoxesValues.agreedTerms,
    fetchBankAccountToken,
    isValidAddress,
    isValidBankAccount,
    recurlyTokenDetail,
  ])
  if (isMobileViewEnable && !skipOldMobile) {
    return (
      <form
        ref={formRef}
        onInput={handleNativeFormChange}
        onChange={handleNativeFormChange}
      >
        <div style={{display: showFirstSection ? 'block' : 'none'}}>
          <div>
            <div>
              <p className="payment-variant-label">Company Name</p>
              <input
                className="recurly-element recurly-input w-100"
                style={{height: is5Order ? '35px' : '45px'}}
                data-recurly="business_name"
                placeholder="Company Name"
                name="company"
                value={addressInformation.company}
                onChange={handleOnchange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div className="mt-2">
              <p className="payment-variant-label">Phone Number</p>

              <input
                className="recurly-element recurly-input w-100"
                style={{height: is5Order ? '35px' : '45px'}}
                data-recurly="business_phone"
                placeholder="Phone Number"
                name="phone"
                value={addressInformation.phone}
                onChange={handleOnchange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div className="mt-2">
              <p className="payment-variant-label">Account Name</p>
              <input
                className="recurly-element recurly-input w-100"
                style={{height: is5Order ? '35px' : '45px'}}
                data-recurly="name_on_account"
                placeholder="Account Name"
                name="accountName"
                value={bankAccountInformation?.accountName}
                onChange={handleBankAccountChange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>

            <div className="mt-2">
              <p className="payment-variant-label">Routing Number</p>
              <input
                className="recurly-element recurly-input w-100"
                style={{height: is5Order ? '35px' : '45px'}}
                data-recurly="routing_number"
                data-dd-privacy="mask"
                placeholder="Routing Number"
                name="routingNumber"
                value={bankAccountInformation?.routingNumber}
                onChange={handleBankAccountChange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div className="mt-2">
              <p className="payment-variant-label">Account Number</p>
              <input
                className="recurly-element recurly-input w-100"
                style={{height: is5Order ? '35px' : '45px'}}
                data-recurly="account_number"
                data-dd-privacy="mask"
                placeholder="Account Number"
                name="accountNumber"
                value={bankAccountInformation?.accountNumber}
                onChange={handleBankAccountChange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div className="mt-2">
              <p className="payment-variant-label">Confirm Account Number</p>
              <input
                className="recurly-element recurly-input w-100"
                style={{height: is5Order ? '35px' : '45px'}}
                data-recurly="account_number_confirmation"
                data-dd-privacy="mask"
                placeholder="Account Number Confirmation"
                name="accountNumberConfirmation"
                onChange={handleBankAccountChange}
                value={bankAccountInformation?.accountNumberConfirmation}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
              {bankAccountInformation?.accountNumberConfirmation?.length > 0 &&
                bankAccountInformation?.accountNumber !==
                  bankAccountInformation?.accountNumberConfirmation && (
                  <p style={{color: 'red', fontSize: '12px', marginTop: '4px'}}>
                    Account numbers do not match.
                  </p>
                )}
            </div>

            <div className="mt-2">
              <p className="payment-variant-label">Banking Account Type</p>
              <div className="d-flex gap-3 mt-2">
                {ACCOUNT_TYPE_OPTIONS.map(item => (
                  <div
                    key={item.label}
                    style={{display: 'flex', alignItems: 'center', gap: '6px'}}
                  >
                    <input
                      type="radio"
                      id={item.value}
                      name="accountType"
                      data-recurly="account_type"
                      data-dd-privacy="mask"
                      value={item.value}
                      checked={
                        bankAccountInformation?.accountType === item.value
                      }
                      onChange={() => {
                        handleBankAccountChange({
                          target: {name: 'accountType', value: item.value},
                        })
                      }}
                      style={{
                        margin: 0,
                        cursor: 'pointer',
                        accentColor: '#5378FC',
                      }}
                    />
                    <label
                      htmlFor={item.value}
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#4D4D4D',
                        marginBottom: 0,
                        position: 'static',
                        cursor: 'pointer',
                      }}
                    >
                      {item.label}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <input
              type="text"
              placeholder="Postal Code"
              data-recurly="postal_code"
              style={{
                fontSize: '18px',
                width: '96%',
              }}
              onChange={e => {
                handleOnchange(e)
              }}
              className="recurly-element recurly-address"
              name="postalCode"
              value={
                addressInformation.postalCode || addressInformation.postCode
              }
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: isMobileViewEnable ? 'column' : undefined,
              gap: '16px',
              alignItems: isMobileViewEnable ? 'stretch' : 'flex-start',
            }}
          >
            <div style={{flex: 1}}>
              <Select
                options={COUNTRIES}
                selectLabel="Country"
                width="full"
                className="recurly-element recurly-address mt-3"
                data-recurly="country"
                selectedOption={selectedCountry}
                setSelectedOption={setSelectedCountry}
                disabled={!allowCountryChange || checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div
              style={{
                flex: 3,
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                paddingTop: '16px',
              }}
            >
              {disclaimerText && (
                <p className="card-number-helper-text" style={{margin: 0}}>
                  {disclaimerText}
                </p>
              )}
              <p className="card-number-helper-text" style={{margin: 0}}>
                {
                  "By processing your payment, you agree that your personal information will be shared with Thryv's payment processor—Adyen, N.V. and will be subject to Adyen's "
                }
                <a
                  target="_blank"
                  href="https://www.adyen.com/policies-and-disclaimer/privacy-policy"
                  rel="noreferrer"
                  style={{fontWeight: 700, color: '#5378FC'}}
                >
                  privacy statement
                </a>
                {'.'}
              </p>
            </div>
          </div>
          <input
            hidden
            readOnly
            type="text"
            placeholder="Country"
            value={selectedCountry.value}
            style={{
              fontSize: '18px',
            }}
            className="recurly-element recurly-address ml-2"
            data-recurly="country"
          />
          <input
            hidden
            readOnly
            type="text"
            placeholder="Phone"
            value={bizphone}
            style={{
              fontSize: '18px',
            }}
            className="recurly-element recurly-address ml-2"
            data-recurly="phone"
          />
          <div className="d-flex justify-content-center mb-4 mt-4">
            <Button
              variant="primary"
              onClick={() => {
                dispatch(nextPaymentStep())
              }}
              className="step__container__button"
              disabled={
                !isValidBankAccount ||
                !addressInformation.postalCode ||
                !addressInformation.phone ||
                !addressInformation.company
              }
            >
              Continue
            </Button>
          </div>
        </div>
        {showSecondSection && (
          <>
            {!isAusNZ && (
              <div
                className="d-flex align-center    info__alert gap-2 px-2"
                style={{
                  background: 'rgb(230, 242, 255)',
                  border: '1px solid rgb(193, 222, 255)',
                  borderRadius: '5px',
                  alignItems: 'center',
                }}
              >
                <Icon type="solid" variant="infoCircle" color="#057aff" />
                <ParagraphText
                  variant="reg"
                  style={{marginTop: '10px', fontSize: '12px'}}
                >
                  The current estimated taxes are based on your business
                  address.
                </ParagraphText>
              </div>
            )}
            <div className="mt-4 mb-2">
              <Checkbox
                hasLabel
                name="useBusinessAddressInfo"
                disabled={checkBoxesValues.agreedTerms}
                checked={checkBoxesValues.useBusinessAddressInfo}
                onChange={e => {
                  setCheckBoxesValues({
                    ...checkBoxesValues,
                    useBusinessAddressInfo: e.target.checked,
                  })
                }}
                label="Same as my business address"
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div className="d-flex justify-content-between">
              <input
                style={{width: ' 49%'}}
                onChange={handleOnchange}
                className="recurly-element recurly-input"
                data-recurly="first_name"
                placeholder="First Name"
                name="firstName"
                value={addressInformation.firstName}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
              <input
                style={{width: '49%'}}
                className="recurly-element recurly-input"
                data-recurly="last_name"
                placeholder="Last Name"
                name="lastName"
                value={addressInformation.lastName}
                onChange={handleOnchange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <input
              type="text"
              className="recurly-element recurly-address"
              data-recurly="address1"
              placeholder="Address"
              style={{
                fontSize: '18px',
              }}
              name="address"
              value={addressInformation.address}
              onChange={handleOnchange}
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            />
            <input
              type="text"
              className="recurly-element recurly-input mt-2.8"
              data-recurly="city"
              placeholder="City"
              style={{
                fontSize: '18px',
              }}
              name="city"
              value={addressInformation.city}
              onChange={handleOnchange}
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            />
            <select
              className="recurly-element recurly-address mt-2.8"
              name="state"
              value={addressInformation?.state}
              onChange={e => {
                handleOnchange({
                  target: {
                    name: 'state',
                    value: e.target.selectedOptions[0].value,
                  },
                })
              }}
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            >
              {listOfStates.map(({name, value}) => {
                return (
                  <option key={value} value={value}>
                    {name}
                  </option>
                )
              })}
            </select>
            <input
              hidden
              readOnly
              value={addressInformation?.state}
              type="text"
              className="recurly-element"
              data-recurly="state"
              placeholder="State"
              style={{
                fontSize: '18px',
              }}
            />

            <div className="mt-4 mb-2">
              <Checkbox
                hasLabel
                name="updateBillingAddress"
                disabled={
                  checkBoxesValues.agreedTerms || useBusinessAddressInfo
                }
                checked={checkBoxesValues.updateBillingAddress}
                onChange={e => {
                  setCheckBoxesValues({
                    ...checkBoxesValues,
                    updateBillingAddress: e.target.checked,
                  })
                }}
                label="Update my billing address"
              />
            </div>
            <div className="d-flex justify-content-center mb-4 mt-4">
              <div className="d-flex justify-content-center mb-4 mt-4">
                <Button
                  variant="primary"
                  onClick={() => dispatch(nextPaymentStep())}
                  className="step__container__button"
                  disabled={!isValidAddress}
                >
                  Continue
                </Button>
              </div>
            </div>
          </>
        )}
      </form>
    )
  }
  return (
    <form
      ref={formRef}
      onInput={handleNativeFormChange}
      onChange={handleNativeFormChange}
      style={{display: 'flex', flexDirection: 'column', gap: '10px'}}
    >
      <div
        className="d-flex justify-content-between mb-1"
        style={{
          marginTop: is5Order && !isAusNZ ? '10px' : '0',
        }}
      ></div>
      <div style={{background: 'white', borderRadius: '10px', padding: '16px'}}>
        <div className="section-heading section-heading--no-divider">
          <div className="section-heading-title-container">
            <Tooltip
              variant="bottom"
              description="Provide bank account details to proceed with payment"
              width="220px"
            >
              <div
                className="d-flex align-items-center"
                style={{columnGap: '4px'}}
              >
                <p className="section-heading-title">Bank Account Details</p>
                <Icon
                  type="regular"
                  variant="infoCircle"
                  color="#808080"
                  width="11"
                  height="11"
                />
              </div>
            </Tooltip>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            marginTop: '10px',
          }}
        >
          <div style={{display: 'flex', gap: '10px'}}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                flex: 1,
              }}
            >
              <label className="payment-variant-label">First Name</label>
              <input
                className="recurly-element recurly-input"
                style={{
                  height: '32px',
                  border: '1px solid #bfbfbf',
                  borderRadius: '5px',
                  background: '#ffffff',
                  padding: '8px',
                  fontFamily: 'Open Sans',
                  fontSize: '12px',
                  fontWeight: '400',
                  marginTop: 0,
                  width: '100%',
                }}
                data-recurly="first_name"
                placeholder="First Name"
                name="firstName"
                onChange={handleOnchange}
                value={addressInformation.firstName}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                flex: 1,
              }}
            >
              <label className="payment-variant-label">Last Name</label>
              <input
                className="recurly-element recurly-input"
                style={{
                  height: '32px',
                  border: '1px solid #bfbfbf',
                  borderRadius: '5px',
                  background: '#ffffff',
                  padding: '8px',
                  fontFamily: 'Open Sans',
                  fontSize: '12px',
                  fontWeight: '400',
                  marginTop: 0,
                  width: '100%',
                }}
                data-recurly="last_name"
                placeholder="Last Name"
                name="lastName"
                onChange={handleOnchange}
                value={addressInformation.lastName}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
          </div>
          <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
            <label className="payment-variant-label">Company Name</label>
            <input
              className="recurly-element recurly-input"
              style={{
                height: '32px',
                border: '1px solid #bfbfbf',
                borderRadius: '5px',
                background: '#ffffff',
                padding: '8px',
                fontFamily: 'Open Sans',
                fontSize: '12px',
                fontWeight: '400',
                marginTop: 0,
                width: '100%',
              }}
              data-recurly="business_name"
              placeholder="Company Name"
              name="company"
              onChange={handleOnchange}
              value={addressInformation.company}
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            />
          </div>
          <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
            <label className="payment-variant-label">Phone Number</label>
            <input
              className="recurly-element recurly-input"
              style={{
                height: '32px',
                border: '1px solid #bfbfbf',
                borderRadius: '5px',
                background: '#ffffff',
                padding: '8px',
                fontFamily: 'Open Sans',
                fontSize: '12px',
                fontWeight: '400',
                marginTop: 0,
                width: '100%',
              }}
              data-recurly="business_phone"
              placeholder="Phone Number"
              name="phone"
              onChange={handleOnchange}
              value={addressInformation.phone}
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            />
          </div>
          <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
            <label className="payment-variant-label">Account Name</label>
            <input
              className="recurly-element recurly-input"
              style={{
                height: '32px',
                border: '1px solid #bfbfbf',
                borderRadius: '5px',
                background: '#ffffff',
                padding: '8px',
                fontFamily: 'Open Sans',
                fontSize: '12px',
                fontWeight: '400',
                marginTop: 0,
                width: '100%',
              }}
              data-recurly="name_on_account"
              placeholder="Account Name"
              name="accountName"
              onChange={handleBankAccountChange}
              value={bankAccountInformation?.accountName}
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            />
          </div>
          <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
            <label className="payment-variant-label">Routing Number</label>
            <input
              className="recurly-element recurly-input"
              style={{
                height: '32px',
                border: '1px solid #bfbfbf',
                borderRadius: '5px',
                background: '#ffffff',
                padding: '8px',
                fontFamily: 'Open Sans',
                fontSize: '12px',
                fontWeight: '400',
                marginTop: 0,
                width: '100%',
              }}
              data-recurly="routing_number"
              data-dd-privacy="mask"
              placeholder="Routing Number"
              name="routingNumber"
              onChange={handleBankAccountChange}
              value={bankAccountInformation?.routingNumber}
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            />
          </div>
          <div style={{display: 'flex', gap: '10px'}}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                flex: 1,
              }}
            >
              <label className="payment-variant-label">Account Number</label>
              <input
                className="recurly-element recurly-input"
                style={{
                  height: '32px',
                  border: '1px solid #bfbfbf',
                  borderRadius: '5px',
                  background: '#ffffff',
                  padding: '8px',
                  fontFamily: 'Open Sans',
                  fontSize: '12px',
                  fontWeight: '400',
                  marginTop: 0,
                  width: '100%',
                }}
                data-recurly="account_number"
                data-dd-privacy="mask"
                placeholder="Account Number"
                name="accountNumber"
                onChange={handleBankAccountChange}
                value={bankAccountInformation?.accountNumber}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                flex: 1,
              }}
            >
              <label className="payment-variant-label">
                Confirm Account Number
              </label>
              <input
                className="recurly-element recurly-input"
                style={{
                  height: '32px',
                  border: '1px solid #bfbfbf',
                  borderRadius: '5px',
                  background: '#ffffff',
                  padding: '8px',
                  fontFamily: 'Open Sans',
                  fontSize: '12px',
                  fontWeight: '400',
                  marginTop: 0,
                  width: '100%',
                }}
                data-recurly="account_number_confirmation"
                data-dd-privacy="mask"
                placeholder="Account Number Confirmation"
                name="accountNumberConfirmation"
                onChange={handleBankAccountChange}
                value={bankAccountInformation?.accountNumberConfirmation}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
              {bankAccountInformation?.accountNumberConfirmation?.length > 0 &&
                bankAccountInformation?.accountNumber !==
                  bankAccountInformation?.accountNumberConfirmation && (
                  <p style={{color: 'red', fontSize: '12px', marginTop: '4px'}}>
                    Account numbers do not match.
                  </p>
                )}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
            }}
          >
            <p className="payment-variant-label">Banking Account Type</p>
            <div className="d-flex gap-3 mt-1">
              {ACCOUNT_TYPE_OPTIONS.map(item => (
                <div
                  key={item.label}
                  style={{display: 'flex', alignItems: 'center', gap: '6px'}}
                >
                  <input
                    type="radio"
                    id={item.value}
                    name="accountType"
                    data-recurly="account_type"
                    data-dd-privacy="mask"
                    value={item.value}
                    checked={bankAccountInformation?.accountType === item.value}
                    onChange={() => {
                      console.log(item.value)
                      handleBankAccountChange({
                        target: {name: 'accountType', value: item.value},
                      })
                    }}
                    style={{
                      margin: 0,
                      cursor: 'pointer',
                      accentColor: '#5378FC',
                    }}
                  />
                  <label
                    htmlFor={item.value}
                    style={{
                      fontFamily: 'Open Sans',
                      fontSize: '12px',
                      fontWeight: 400,
                      color: '#4D4D4D',
                      marginBottom: 0,
                      position: 'static',
                      cursor: 'pointer',
                    }}
                  >
                    {item.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
        {frontendUpdatedTerms && <AutopayTerms />}
      </div>
      <div style={{background: 'white', borderRadius: '10px', padding: '16px'}}>
        {is5Order && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div className="section-heading section-heading--no-divider">
              <div className="section-heading-title-container">
                <div
                  className="d-flex align-items-center"
                  style={{columnGap: '16px'}}
                >
                  <Tooltip
                    variant="top"
                    description="Provide the billing address for this payment"
                    width="220px"
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{columnGap: '4px'}}
                    >
                      <p className="section-heading-title">Billing Address</p>
                      <Icon
                        type="regular"
                        variant="infoCircle"
                        color="#808080"
                        width="11"
                        height="11"
                      />
                    </div>
                  </Tooltip>
                  <div
                    className="d-flex align-items-center"
                    style={{columnGap: '6px'}}
                  >
                    <input
                      type="checkbox"
                      id="useBusinessAddressInfoAch"
                      name="useBusinessAddressInfo"
                      disabled={checkBoxesValues.agreedTerms}
                      checked={checkBoxesValues.useBusinessAddressInfo}
                      onChange={e => {
                        setCheckBoxesValues({
                          ...checkBoxesValues,
                          useBusinessAddressInfo: e.target.checked,
                        })
                      }}
                      title={
                        checkBoxesValues.agreedTerms
                          ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                          : undefined
                      }
                      style={{
                        cursor: 'pointer',
                        width: '16px',
                        height: '16px',
                        accentColor: '#5378FC',
                      }}
                    />
                    <label
                      htmlFor="useBusinessAddressInfoAch"
                      className="business-address-label"
                      style={{cursor: 'pointer', marginBottom: '0px'}}
                    >
                      Same as my business address
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {!is5Order && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div className="section-heading section-heading--no-divider">
              <div className="section-heading-title-container">
                <div
                  className="d-flex align-items-center"
                  style={{columnGap: '16px'}}
                >
                  <Tooltip
                    variant="top"
                    description="Provide the billing address for this payment"
                    width="220px"
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{columnGap: '4px'}}
                    >
                      <p className="section-heading-title">Billing Address</p>
                      <Icon
                        type="regular"
                        variant="infoCircle"
                        color="#808080"
                        width="11"
                        height="11"
                      />
                    </div>
                  </Tooltip>
                  <div
                    className="d-flex align-items-center"
                    style={{columnGap: '6px'}}
                  >
                    <input
                      type="checkbox"
                      id="useBusinessAddressInfoAchDesktop"
                      name="useBusinessAddressInfo"
                      disabled={checkBoxesValues.agreedTerms}
                      checked={checkBoxesValues.useBusinessAddressInfo}
                      onChange={e => {
                        setCheckBoxesValues({
                          ...checkBoxesValues,
                          useBusinessAddressInfo: e.currentTarget.checked,
                        })
                      }}
                      title={
                        checkBoxesValues.agreedTerms
                          ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                          : undefined
                      }
                      style={{
                        cursor: 'pointer',
                        width: '16px',
                        height: '16px',
                        accentColor: '#5378FC',
                      }}
                    />
                    <label
                      htmlFor="useBusinessAddressInfoAchDesktop"
                      className="business-address-label"
                      style={{cursor: 'pointer', marginBottom: '0px'}}
                    >
                      Same as my business address
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {is5Order && isAddressUpdated && (
          <TaxesPromptContainer>
            <Icon type="regular" variant="infoCircle" color="#057AFF" />
            <ParagraphText variant="reg" className="m-0">
              The current estimated taxes are based on your business address.
            </ParagraphText>
          </TaxesPromptContainer>
        )}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            marginTop: '10px',
          }}
        >
          <input
            hidden
            readOnly
            type="text"
            placeholder="Country"
            value={selectedCountry.value}
            className="recurly-element recurly-address"
            data-recurly="country"
          />
          <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
            <label className="payment-variant-label">Street Address</label>
            <input
              type="text"
              className="recurly-element"
              data-recurly="address1"
              placeholder="Street Address"
              style={{
                height: '32px',
                border: '1px solid #bfbfbf',
                borderRadius: '5px',
                background: '#ffffff',
                padding: '8px',
                fontFamily: 'Open Sans',
                fontSize: '12px',
                fontWeight: '400',
                marginTop: 0,
                width: '100%',
              }}
              name="address"
              value={addressInformation.address}
              onChange={handleOnchange}
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            />
          </div>
          <div className="grid grid-cols-3 gap-2">
            <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
              <label className="payment-variant-label">City</label>
              <input
                type="text"
                className="recurly-element"
                data-recurly="city"
                placeholder="City"
                style={{
                  height: '32px',
                  border: '1px solid #bfbfbf',
                  borderRadius: '5px',
                  background: '#ffffff',
                  padding: '8px',
                  fontFamily: 'Open Sans',
                  fontSize: '12px',
                  fontWeight: '400',
                  marginTop: 0,
                }}
                name="city"
                value={addressInformation.city}
                onChange={handleOnchange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
              <label className="payment-variant-label">State</label>
              <select
                className="recurly-element"
                name="state"
                value={addressInformation?.state}
                style={{
                  height: '32px',
                  border: '1px solid #bfbfbf',
                  borderRadius: '5px',
                  fontFamily: 'Open Sans',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '100%',
                  paddingLeft: '8px',
                  marginTop: 0,
                }}
                onChange={e => {
                  handleOnchange({
                    target: {
                      name: 'state',
                      value: e.target.selectedOptions[0].value,
                    },
                  })
                }}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              >
                {listOfStates.map(({name, value}) => {
                  return (
                    <option key={value} value={value}>
                      {name}
                    </option>
                  )
                })}
              </select>
              <input
                hidden
                readOnly
                value={addressInformation?.state}
                type="text"
                className="recurly-element"
                data-recurly="state"
                placeholder="State"
              />
            </div>
            <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
              <label className="payment-variant-label">Postal Code</label>
              <input
                type="text"
                className="recurly-element"
                data-recurly="postal_code"
                placeholder="Postal Code"
                style={{
                  height: '32px',
                  border: '1px solid #bfbfbf',
                  borderRadius: '5px',
                  background: '#ffffff',
                  padding: '8px',
                  fontFamily: 'Open Sans',
                  fontSize: '12px',
                  fontWeight: '400',
                  marginTop: 0,
                }}
                name="postalCode"
                value={
                  addressInformation.postalCode || addressInformation.postCode
                }
                onChange={handleOnchange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
          </div>
          {!is5Order && (
            <div
              style={{
                display: 'flex',
                flexDirection: isMobileViewEnable ? 'column' : undefined,
                gap: '16px',
                alignItems: isMobileViewEnable ? 'stretch' : 'flex-start',
              }}
            >
              <div style={{flex: 1}}>
                <div
                  style={{display: 'flex', flexDirection: 'column', gap: '4px'}}
                >
                  <label className="payment-variant-label">Country</label>
                  <div
                    style={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <select
                      className="recurly-element recurly-address"
                      data-recurly="country"
                      value={selectedCountry?.value}
                      onChange={e => {
                        setSelectedCountry(
                          COUNTRIES.find(c => c.value === e.target.value),
                        )
                      }}
                      disabled={
                        !allowCountryChange || checkBoxesValues.agreedTerms
                      }
                      style={{
                        width: '100%',
                        height: '32px',
                        border: '1px solid #bfbfbf',
                        borderRadius: '5px',
                        fontFamily: 'Open Sans',
                        fontWeight: 400,
                        fontSize: '12px',
                        lineHeight: '100%',
                        paddingLeft: '8px',
                        paddingRight: '28px',
                        marginTop: 0,
                        appearance: 'none',
                        WebkitAppearance: 'none',
                      }}
                    >
                      {COUNTRIES.map(({name, value}) => (
                        <option key={value} value={value}>
                          {name}
                        </option>
                      ))}
                    </select>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 20 20"
                      fill="none"
                      style={{
                        position: 'absolute',
                        right: '8px',
                        pointerEvents: 'none',
                      }}
                    >
                      <path
                        d="M5 7.5L10 12.5L15 7.5"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div
                style={{
                  flex: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  paddingTop: '16px',
                }}
              >
                {disclaimerText && (
                  <p className="card-number-helper-text" style={{margin: 0}}>
                    {disclaimerText}
                  </p>
                )}
                <p className="card-number-helper-text" style={{margin: 0}}>
                  {
                    "By processing your payment, you agree that your personal information will be shared with Thryv's payment processor—Adyen, N.V. and will be subject to Adyen's "
                  }
                  <a
                    target="_blank"
                    href="https://www.adyen.com/policies-and-disclaimer/privacy-policy"
                    rel="noreferrer"
                    style={{fontWeight: 700, color: '#5378FC'}}
                  >
                    privacy statement
                  </a>
                  {'.'}
                </p>
              </div>
            </div>
          )}
          {is5Order && (
            <div
              style={{display: 'flex', flexDirection: 'column', gap: '16px'}}
            >
              <div
                style={{
                  opacity: '0.6',
                  pointerEvents: 'none',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                }}
              >
                <label className="payment-variant-label">Country</label>
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <select
                    className="payment-country-select"
                    data-recurly="country"
                    value={selectedCountry?.value}
                    onChange={e => {
                      setSelectedCountry(
                        COUNTRIES.find(c => c.value === e.target.value),
                      )
                    }}
                    disabled={
                      !allowCountryChange || checkBoxesValues.agreedTerms
                    }
                    style={{
                      width: '100%',
                      height: '32px',
                      border: '1px solid #bfbfbf',
                      borderRadius: '5px',
                      fontFamily: 'Open Sans',
                      fontWeight: 400,
                      fontSize: '12px',
                      lineHeight: '100%',
                      paddingLeft: '8px',
                      paddingRight: '28px',
                      marginTop: 0,
                      appearance: 'none',
                      WebkitAppearance: 'none',
                    }}
                  >
                    {COUNTRIES.map(({name, value}) => (
                      <option key={value} value={value}>
                        {name}
                      </option>
                    ))}
                  </select>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 20 20"
                    fill="none"
                    style={{
                      position: 'absolute',
                      right: '8px',
                      pointerEvents: 'none',
                    }}
                  >
                    <path
                      d="M5 7.5L10 12.5L15 7.5"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  paddingTop: '4px',
                }}
              >
                {disclaimerText && (
                  <p className="card-number-helper-text" style={{margin: 0}}>
                    {disclaimerText}
                  </p>
                )}
                <p className="card-number-helper-text" style={{margin: 0}}>
                  {
                    "By processing your payment, you agree that your personal information will be shared with Thryv's payment processor—Adyen, N.V. and will be subject to Adyen's "
                  }
                  <a
                    target="_blank"
                    href="https://www.adyen.com/policies-and-disclaimer/privacy-policy"
                    rel="noreferrer"
                    style={{fontWeight: 700, color: '#5378FC'}}
                  >
                    privacy statement
                  </a>
                  {'.'}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </form>
  )
}

const AchPaymentForm = ({
  nextStep,
  calculateTaxes,
  calculatingTaxes,
  setCalculatingTaxes,
  showFirstSection = false,
  showSecondSection = false,
  checkBoxesValues,
  setCheckBoxesValues,
  setName,
  businessAddress,
  country,
  handleCompleteOrder,
  setIsAddressUpdated,
  bizphone,
  is5Order,
  isAddressUpdated,
  paymentPreview,
  disclaimerText,
  allowCountryChange = false,
  skipOldMobile = false,
}) => {
  return (
    <Elements>
      <AchRecurlyPaymentForm
        saveRecurlyToken={calculateTaxes}
        calculatingTaxes={calculatingTaxes}
        setCalculatingTaxes={setCalculatingTaxes}
        showFirstSection={showFirstSection}
        showSecondSection={showSecondSection}
        nextStep={nextStep}
        checkBoxesValues={checkBoxesValues}
        setCheckBoxesValues={setCheckBoxesValues}
        setName={setName}
        businessAddress={businessAddress}
        country={country}
        handleCompleteOrder={handleCompleteOrder}
        setIsAddressUpdated={setIsAddressUpdated}
        bizphone={bizphone}
        is5Order={is5Order}
        isAddressUpdated={isAddressUpdated}
        paymentPreview={paymentPreview}
        disclaimerText={disclaimerText}
        allowCountryChange={allowCountryChange}
        skipOldMobile={skipOldMobile}
      />
    </Elements>
  )
}

export {AchPaymentForm}
